import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksAccountLineItemsSection.AmountCell', {
    warning: 'Bill line amount differs from File line amount.',
    differenceWarningBill: 'Bill line amount:',
    differenceWarningFile: 'File line amount:',
});
